module.exports = __webpack_public_path__ + "img/rowB4.b2d46987.png";